module.exports = __webpack_public_path__ + "static/media/3.b52c9d75.png";